webpackJsonp([18],{

/***/ 1220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _EditPDFLandingPageWrapper = __webpack_require__(1433);

var _EditPDFLandingPageWrapper2 = _interopRequireDefault(_EditPDFLandingPageWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditPDFLandingPage = function EditPDFLandingPage() {
  return _react2.default.createElement(_EditPDFLandingPageWrapper2.default, { layout: 'freeWriteBackground' });
};

exports.default = (0, _WithInit2.default)(EditPDFLandingPage);

/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _EditPDFLandingPage = __webpack_require__(1220);

var _EditPDFLandingPage2 = _interopRequireDefault(_EditPDFLandingPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.EditPDFLandingPage = _EditPDFLandingPage2.default;

/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EditPDFLandingPageFullWidthUploadPanel = __webpack_require__(823);

var _EditPDFLandingPageFullWidthUploadPanel2 = _interopRequireDefault(_EditPDFLandingPageFullWidthUploadPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditPDFLandingPageFreeWriteBackgroundLayout = function EditPDFLandingPageFreeWriteBackgroundLayout(props) {
  return _react2.default.createElement(
    'div',
    {
      className: '\n      edit-pdf-container\n      large-upload-panel-mock-freewrite-wrapper\n      large-upload-panel-wrapper\n    '
    },
    _react2.default.createElement('img', {
      src: '/images/freewrite-toolbar.png',
      alt: 'Mock Free Write Background',
      className: 'large-upload-panel-mock-freewrite-bg-img img-lg'
    }),
    _react2.default.createElement('img', {
      src: '/images/freewrite-toolbar-xs.png',
      alt: 'Mock Free Write Background',
      className: 'large-upload-panel-mock-freewrite-bg-img img-xs'
    }),
    _react2.default.createElement(_EditPDFLandingPageFullWidthUploadPanel2.default, {
      ctaId: props.ctaId,
      headerCopy: 'PDF Editor',
      subHeader: 'Upload any PDF, Word Document, or Image to get started.'
    })
  );
};

EditPDFLandingPageFreeWriteBackgroundLayout.propTypes = {
  ctaId: _propTypes2.default.string.isRequired
};

exports.default = EditPDFLandingPageFreeWriteBackgroundLayout;

/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EditPDFLandingPageFullWidthUploadPanel = __webpack_require__(823);

var _EditPDFLandingPageFullWidthUploadPanel2 = _interopRequireDefault(_EditPDFLandingPageFullWidthUploadPanel);

var _EditPDFLandingPageBenefitsSection = __webpack_require__(822);

var _EditPDFLandingPageBenefitsSection2 = _interopRequireDefault(_EditPDFLandingPageBenefitsSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditPDFLandingPageFullWidthUploadPanelLayout = function EditPDFLandingPageFullWidthUploadPanelLayout(props) {
  return _react2.default.createElement(
    'div',
    { className: 'indexRedesign large-upload-panel-wrapper' },
    _react2.default.createElement(
      'div',
      { className: 'container-fluid' },
      _react2.default.createElement(
        'div',
        { className: 'row-fluid' },
        _react2.default.createElement(
          'div',
          { className: 'span12 editor-landing' },
          _react2.default.createElement(
            'div',
            { className: 'large-upload-panel-info-wrapper' },
            _react2.default.createElement(
              'h1',
              { className: 'large-upload-panel-page-header' },
              'Free PDF Editor'
            ),
            _react2.default.createElement(
              'h2',
              { className: 'large-upload-panel-page-sub-header' },
              'No software required. Simply upload and go!'
            )
          )
        ),
        _react2.default.createElement(_EditPDFLandingPageFullWidthUploadPanel2.default, {
          ctaId: props.ctaId
        })
      ),
      _react2.default.createElement(_EditPDFLandingPageBenefitsSection2.default, { isFullWidthUploadPanel: true })
    )
  );
};

EditPDFLandingPageFullWidthUploadPanelLayout.propTypes = {
  ctaId: _propTypes2.default.string.isRequired
};

exports.default = EditPDFLandingPageFullWidthUploadPanelLayout;

/***/ }),

/***/ 1429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LandingPagePhotoToPDFModal = __webpack_require__(443);

var _LandingPagePhotoToPDFModal2 = _interopRequireDefault(_LandingPagePhotoToPDFModal);

var _EditPDFLandingPageRadioButtons = __webpack_require__(824);

var _EditPDFLandingPageRadioButtons2 = _interopRequireDefault(_EditPDFLandingPageRadioButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditPDFLandingPageLargeUploadPanel = function EditPDFLandingPageLargeUploadPanel() {
  return _react2.default.createElement(
    'div',
    { className: 'span6' },
    _react2.default.createElement(
      'div',
      { className: 'upload-wrap edit-pages-upload-wrap hide-for-photos' },
      _react2.default.createElement(
        'form',
        { id: 'dropzoneUploader', className: 'uploader' },
        _react2.default.createElement(
          'div',
          { className: 'alert alert-error uploader-error' },
          'Error'
        ),
        _react2.default.createElement(
          'a',
          {
            id: 'uploadPDFLargeMobile',
            className: 'btn btn-custom_info is-block is-big is-hidden'
          },
          'Select a file to Upload'
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'uploader-area edit-pages-uploader-area',
            onDrop: window._track('Edit PDF Landing Page', 'Drag and Drop Upload Zone')
          },
          _react2.default.createElement('img', {
            src: '/images/document-and-arrow-icon.png',
            alt: 'Document and Arrow Icon',
            className: 'large-upload-panel-document-icon'
          }),
          _react2.default.createElement(
            'h3',
            { className: 'large-upload-panel-header' },
            'Drag and Drop Your File Here'
          ),
          _react2.default.createElement(
            'p',
            { className: 'large-upload-panel-sub-header' },
            'PDF or Word Document'
          ),
          _react2.default.createElement(_EditPDFLandingPageRadioButtons2.default, null),
          _react2.default.createElement(
            'a',
            {
              id: 'uploadPDFLarge',
              className: 'btn btn-success large-upload-panel-cta-button'
            },
            'Upload a File to Edit'
          )
        )
      )
    ),
    _react2.default.createElement(_LandingPagePhotoToPDFModal2.default, null)
  );
};

exports.default = EditPDFLandingPageLargeUploadPanel;

/***/ }),

/***/ 1430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _EditPDFLandingPageLargeUploadPanel = __webpack_require__(1429);

var _EditPDFLandingPageLargeUploadPanel2 = _interopRequireDefault(_EditPDFLandingPageLargeUploadPanel);

var _EditPDFLandingPageBenefitsSection = __webpack_require__(822);

var _EditPDFLandingPageBenefitsSection2 = _interopRequireDefault(_EditPDFLandingPageBenefitsSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditPDFLandingPageLargeUploadPanelLayout = function EditPDFLandingPageLargeUploadPanelLayout() {
  return _react2.default.createElement(
    'div',
    { className: 'indexRedesign large-upload-panel-wrapper' },
    _react2.default.createElement(
      'div',
      { className: 'container-fluid' },
      _react2.default.createElement(
        'div',
        { className: 'row-fluid' },
        _react2.default.createElement(
          'div',
          { className: 'span6 editor-landing' },
          _react2.default.createElement(
            'div',
            { className: 'large-upload-panel-info-wrapper' },
            _react2.default.createElement(
              'h1',
              { className: 'large-upload-panel-page-header' },
              'Free PDF Editor'
            ),
            _react2.default.createElement(
              'h2',
              { className: 'large-upload-panel-page-sub-header' },
              'No software required. Simply upload and go!'
            ),
            _react2.default.createElement(_EditPDFLandingPageBenefitsSection2.default, null)
          )
        ),
        _react2.default.createElement(_EditPDFLandingPageLargeUploadPanel2.default, null)
      )
    )
  );
};

exports.default = EditPDFLandingPageLargeUploadPanelLayout;

/***/ }),

/***/ 1431:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LandingPagePhotoToPDFModal = __webpack_require__(443);

var _LandingPagePhotoToPDFModal2 = _interopRequireDefault(_LandingPagePhotoToPDFModal);

var _EditPDFLandingPageRadioButtons = __webpack_require__(824);

var _EditPDFLandingPageRadioButtons2 = _interopRequireDefault(_EditPDFLandingPageRadioButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditPDFLandingPageSmallUploadPanel = function EditPDFLandingPageSmallUploadPanel() {
  return _react2.default.createElement(
    'div',
    { className: 'span6' },
    _react2.default.createElement(
      'div',
      { className: 'upload-wrap edit-pages-upload-wrap hide-for-photos' },
      _react2.default.createElement(
        'div',
        {
          className: 'uploader-title edit-pages-uploader-title'
        },
        'Let\u2019s get started!'
      ),
      _react2.default.createElement(_EditPDFLandingPageRadioButtons2.default, null),
      _react2.default.createElement(
        'form',
        { id: 'dropzoneUploader', className: 'uploader' },
        _react2.default.createElement(
          'div',
          { className: 'alert alert-error uploader-error' },
          'Error'
        ),
        _react2.default.createElement(
          'a',
          {
            id: 'uploadPDFLargeMobile',
            className: 'btn btn-custom_info is-block is-big is-hidden'
          },
          'Select a file to Upload'
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'uploader-area edit-pages-uploader-area',
            onDrop: window._track('Edit PDF Landing Page', 'Drag and Drop Upload Zone')
          },
          _react2.default.createElement(
            'div',
            { className: 'uploader-subtitle' },
            'Drag and drop your file here'
          ),
          _react2.default.createElement('img', { src: '/images/icon-drag&drop.png', alt: '' }),
          _react2.default.createElement(
            'div',
            { className: 'uploader-devider' },
            'or'
          ),
          _react2.default.createElement(
            'a',
            {
              id: 'uploadPDFLarge',
              className: 'btn btn-custom_info is-block is-big'
            },
            'Select a file to Upload'
          )
        )
      )
    ),
    _react2.default.createElement(_LandingPagePhotoToPDFModal2.default, null)
  );
};

exports.default = EditPDFLandingPageSmallUploadPanel;

/***/ }),

/***/ 1432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _EditPDFLandingPageSmallUploadPanel = __webpack_require__(1431);

var _EditPDFLandingPageSmallUploadPanel2 = _interopRequireDefault(_EditPDFLandingPageSmallUploadPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditPDFLandingPageSmallUploadPanelLayout = function EditPDFLandingPageSmallUploadPanelLayout() {
  return _react2.default.createElement(
    'div',
    { className: 'indexRedesign' },
    _react2.default.createElement(
      'div',
      { className: 'container-fluid' },
      _react2.default.createElement(
        'div',
        { className: 'row-fluid' },
        _react2.default.createElement(
          'div',
          { className: 'span6 editor-landing' },
          _react2.default.createElement(
            'div',
            { className: 'large-upload-panel-info-wrapper' },
            _react2.default.createElement(
              'h1',
              null,
              'Free PDF Editor'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'The simple PDF editor from FormSwift'
            ),
            _react2.default.createElement(
              'ul',
              { className: 'benifits-list unstyled' },
              _react2.default.createElement(
                'li',
                { className: 'edit-pages-info-tag-wrapper' },
                _react2.default.createElement('img', { src: '/images/edit-pages-icon.png', alt: 'Edit Pages Icon' }),
                _react2.default.createElement(
                  'div',
                  { className: 'edit-pages-info-tag' },
                  _react2.default.createElement(
                    'p',
                    { className: 'new' },
                    'NEW'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Add, Remove, and Reorder Pages.'
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'item-1' },
                'Edit any PDF or Word Document.'
              ),
              _react2.default.createElement(
                'li',
                { className: 'item-2' },
                'E-sign with ease.'
              ),
              _react2.default.createElement(
                'li',
                { className: 'item-3' },
                'Download and print.'
              ),
              _react2.default.createElement(
                'li',
                { className: 'item-4' },
                'Share in seconds.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'No software required. Simply upload and go!'
            )
          )
        ),
        _react2.default.createElement(_EditPDFLandingPageSmallUploadPanel2.default, null)
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'row-fluid press-mentions press-mentions-editor' },
      _react2.default.createElement(
        'div',
        { className: 'span4 basic-stats' },
        _react2.default.createElement('img', { src: '/images/stats-accounts.png', alt: '1.2 million accounts created' }),
        _react2.default.createElement('img', { src: '/images/stats-documents.png', alt: '16 million documents created' })
      ),
      _react2.default.createElement(
        'div',
        { className: 'span8 tv-highlight' },
        _react2.default.createElement(
          'h2',
          null,
          'As Seen In'
        ),
        _react2.default.createElement('img', {
          src: '/images/pressa-gorisontal.png',
          alt: 'As Seen on: Inc, TNW, The Huffington Post, ReadWrite'
        })
      )
    )
  );
};

exports.default = EditPDFLandingPageSmallUploadPanelLayout;

/***/ }),

/***/ 1433:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EditPDFLandingPageSmallUploadPanelLayout = __webpack_require__(1432);

var _EditPDFLandingPageSmallUploadPanelLayout2 = _interopRequireDefault(_EditPDFLandingPageSmallUploadPanelLayout);

var _EditPDFLandingPageLargeUploadPanelLayout = __webpack_require__(1430);

var _EditPDFLandingPageLargeUploadPanelLayout2 = _interopRequireDefault(_EditPDFLandingPageLargeUploadPanelLayout);

var _EditPDFLandingPageFullWidthUploadPanelLayout = __webpack_require__(1428);

var _EditPDFLandingPageFullWidthUploadPanelLayout2 = _interopRequireDefault(_EditPDFLandingPageFullWidthUploadPanelLayout);

var _EditPDFLandingPageFreeWriteBackgroundLayout = __webpack_require__(1427);

var _EditPDFLandingPageFreeWriteBackgroundLayout2 = _interopRequireDefault(_EditPDFLandingPageFreeWriteBackgroundLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditPDFLandingPageWrapper = function (_React$PureComponent) {
  _inherits(EditPDFLandingPageWrapper, _React$PureComponent);

  function EditPDFLandingPageWrapper() {
    _classCallCheck(this, EditPDFLandingPageWrapper);

    return _possibleConstructorReturn(this, (EditPDFLandingPageWrapper.__proto__ || Object.getPrototypeOf(EditPDFLandingPageWrapper)).apply(this, arguments));
  }

  _createClass(EditPDFLandingPageWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.Upload.activateUploadButtonById(this.props.ctaId);
      window.Upload.activateUploadButtonById(this.props.mobileCTAId);

      // Allow users to upload photos
      window.Upload.photoToPDF.init();
    }
  }, {
    key: 'render',
    value: function render() {
      var landingPageComponent = void 0;
      switch (this.props.layout) {
        case 'smallUploadPanel':
          landingPageComponent = _react2.default.createElement(_EditPDFLandingPageSmallUploadPanelLayout2.default, null);
          break;
        case 'largeUploadPanel':
          landingPageComponent = _react2.default.createElement(_EditPDFLandingPageLargeUploadPanelLayout2.default, null);
          break;
        case 'fullWidthUploadPanel':
          landingPageComponent = _react2.default.createElement(_EditPDFLandingPageFullWidthUploadPanelLayout2.default, {
            ctaId: this.props.ctaId
          });
          break;
        case 'freeWriteBackground':
          landingPageComponent = _react2.default.createElement(_EditPDFLandingPageFreeWriteBackgroundLayout2.default, {
            ctaId: this.props.ctaId
          });
          break;
        default:
          landingPageComponent = _react2.default.createElement(_EditPDFLandingPageSmallUploadPanelLayout2.default, null);
          break;
      }

      return landingPageComponent;
    }
  }]);

  return EditPDFLandingPageWrapper;
}(_react2.default.PureComponent);

exports.default = EditPDFLandingPageWrapper;


EditPDFLandingPageWrapper.defaultProps = {
  ctaId: 'uploadPDFLarge',
  layout: 'smallUploadPanel',
  mobileCTAId: 'uploadPDFLargeMobile'
};

EditPDFLandingPageWrapper.propTypes = {
  ctaId: _propTypes2.default.string,
  layout: _propTypes2.default.string,
  mobileCTAId: _propTypes2.default.string
};

/***/ }),

/***/ 1434:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DesignSystem = __webpack_require__(97);

var _UploadTypes = __webpack_require__(450);

var _UploadTypes2 = _interopRequireDefault(_UploadTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullWidthUploadPanelRadioButtons = function FullWidthUploadPanelRadioButtons(props) {
  var options = [{
    defaultChecked: true,
    text: 'I want to edit my PDF only',
    value: _UploadTypes2.default.FreeWrite
  }, {
    defaultChecked: false,
    text: 'I want to edit my PDF & rearrange pages',
    value: _UploadTypes2.default.Rearrange
  }];

  if (props.isTemplateOptionAvailable) {
    var newOptionPill = _react2.default.createElement(
      _DesignSystem.Pill,
      {
        className: 'template-option-pill',
        type: 'alt'
      },
      'NEW'
    );

    options.push({
      children: newOptionPill,
      defaultChecked: false,
      text: 'I want to add fillable fields to my PDF for someone else to fill out',
      value: _UploadTypes2.default.Template
    });
  }

  var onChange = function onChange(e) {
    switch (e.target.value) {
      case _UploadTypes2.default.FreeWrite:
        props.pdfOnlyClick();
        break;
      case _UploadTypes2.default.Rearrange:
        props.rearrangePagesClick();
        break;
      case _UploadTypes2.default.Template:
        props.templateOptionClick();
        break;
      default:
        break;
    }
  };

  return _react2.default.createElement(_DesignSystem.RadioButtons, {
    className: 'upload-type-radio-buttons',
    id: 'uploadType',
    onChange: onChange,
    options: options
  });
};

FullWidthUploadPanelRadioButtons.defaultProps = {
  isTemplateOptionAvailable: false,
  templateOptionClick: null
};

FullWidthUploadPanelRadioButtons.propTypes = {
  isTemplateOptionAvailable: _propTypes2.default.bool,
  pdfOnlyClick: _propTypes2.default.func.isRequired,
  rearrangePagesClick: _propTypes2.default.func.isRequired,
  templateOptionClick: _propTypes2.default.func
};

exports.default = FullWidthUploadPanelRadioButtons;

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Buttons = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandingPageFullWidthUploadPanelCTA = function LandingPageFullWidthUploadPanelCTA(props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'large-upload-panel-cta-wrapper',
      id: props.ctaId,
      onClick: props.ctaOnClick
    },
    _react2.default.createElement(
      _Buttons.PrimaryButton,
      { className: 'large-upload-panel-cta-button', onClick: function onClick() {} },
      props.ctaText
    )
  );
};

LandingPageFullWidthUploadPanelCTA.defaultProps = {
  ctaOnClick: function ctaOnClick() {},
  ctaText: ''
};

LandingPageFullWidthUploadPanelCTA.propTypes = {
  ctaId: _propTypes2.default.string.isRequired,
  ctaOnClick: _propTypes2.default.func,
  ctaText: _propTypes2.default.string
};

exports.default = LandingPageFullWidthUploadPanelCTA;

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Buttons = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LandingPagePhotoToPDFModal = function (_React$PureComponent) {
  _inherits(LandingPagePhotoToPDFModal, _React$PureComponent);

  function LandingPagePhotoToPDFModal() {
    _classCallCheck(this, LandingPagePhotoToPDFModal);

    return _possibleConstructorReturn(this, (LandingPagePhotoToPDFModal.__proto__ || Object.getPrototypeOf(LandingPagePhotoToPDFModal)).apply(this, arguments));
  }

  _createClass(LandingPagePhotoToPDFModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { id: 'photoToPDF', className: 'hidden centered photoToPDF' },
        _react2.default.createElement(
          'div',
          { className: 'image-upload-heading-container' },
          _react2.default.createElement(
            'p',
            { className: 'image-upload-text' },
            'Rearrange, Add, Delete Images'
          ),
          _react2.default.createElement(
            'div',
            { className: 'image-upload-buttons-container' },
            _react2.default.createElement(
              'div',
              { id: 'addImages-btn', className: 'addImages-btn ds-btn-secondary sm dark' },
              'Add Images',
              _react2.default.createElement('input', {
                type: 'file',
                accept: 'application/msword,\n                  application/vnd.openxmlformats-officedocument.wordprocessingml.document\n                  application/pdf,\n                  image/*',
                id: 'selectPhotos',
                name: 'files[]',
                multiple: true
              })
            ),
            _react2.default.createElement(
              _Buttons.PrimaryButton,
              { onClick: LandingPagePhotoToPDFModal.createPDF, size: 'sm' },
              _react2.default.createElement(
                'span',
                null,
                'Create PDF'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'photo-wrapper' },
          _react2.default.createElement('ul', { id: 'photoList' })
        )
      );
    }
  }], [{
    key: 'createPDF',
    value: function createPDF() {
      window.Upload.photoToPDF.createPDF();
      window._track('create-pdf-from-image', 'edit-pdf page');
    }
  }]);

  return LandingPagePhotoToPDFModal;
}(_react2.default.PureComponent);

exports.default = LandingPagePhotoToPDFModal;

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UploadTypes = {
  EditRequestSignature: 'edit-request-signature',
  EditSign: 'edit-sign',
  FreeWrite: 'free-write',
  Rearrange: 'rearrange',
  Template: 'template'
};

exports.default = UploadTypes;

/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditPDFLandingPageBenefitsSection = function EditPDFLandingPageBenefitsSection(props) {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: 'large-upload-panel-benefits-list' },
      _react2.default.createElement(
        'div',
        { className: 'large-upload-panel-benefits-list-row' },
        _react2.default.createElement(
          'div',
          { className: 'large-upload-panel-benefits-list-item' },
          _react2.default.createElement('img', {
            alt: 'Benefit Icon',
            className: 'large-upload-panel-benefits-list-item-icon',
            src: '/images/pencil-icon.png'
          }),
          _react2.default.createElement(
            'p',
            {
              className: 'large-upload-panel-benefits-list-item-text'
            },
            'Erase and add text.'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'large-upload-panel-benefits-list-item' },
          _react2.default.createElement('img', {
            alt: 'Benefit Icon',
            className: 'large-upload-panel-benefits-list-item-icon',
            src: '/images/share-icon.png'
          }),
          _react2.default.createElement(
            'p',
            {
              className: 'large-upload-panel-benefits-list-item-text'
            },
            'Share in seconds.'
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'large-upload-panel-benefits-list-row' },
        _react2.default.createElement(
          'div',
          { className: 'large-upload-panel-benefits-list-item' },
          _react2.default.createElement('img', {
            alt: 'Benefit Icon',
            className: 'large-upload-panel-benefits-list-item-icon',
            src: '/images/sign-arrow-icon.png'
          }),
          _react2.default.createElement(
            'p',
            {
              className: 'large-upload-panel-benefits-list-item-text'
            },
            'E-sign with ease.'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'large-upload-panel-benefits-list-item' },
          _react2.default.createElement('img', {
            alt: 'Benefit Icon',
            className: 'large-upload-panel-benefits-list-item-icon',
            src: '/images/printer-icon.png'
          }),
          _react2.default.createElement(
            'p',
            {
              className: 'large-upload-panel-benefits-list-item-text'
            },
            'Download and print.'
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'large-upload-panel-testimonial-wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'large-upload-panel-testimonial-column' },
        _react2.default.createElement(
          'p',
          { className: 'large-upload-panel-testimonial-large-text' },
          '1.2 million'
        ),
        _react2.default.createElement(
          'p',
          { className: 'large-upload-panel-testimonial-small-text' },
          'customer accounts'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'large-upload-panel-testimonial-column' },
        _react2.default.createElement(
          'p',
          { className: 'large-upload-panel-testimonial-large-text' },
          '16 million'
        ),
        _react2.default.createElement(
          'p',
          { className: 'large-upload-panel-testimonial-small-text' },
          'documents created'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'large-upload-panel-testimonial-column press-logo-set' },
        props.isFullWidthUploadPanel ? _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement('img', {
            alt: 'Press Icon TNW',
            className: 'large-upload-panel-testimonial-press-icon tnw-icon',
            src: '/images/tnw-icon.png'
          }),
          _react2.default.createElement('img', {
            alt: 'Press Icon Inc',
            className: 'large-upload-panel-testimonial-press-icon',
            src: '/images/inc-icon.png'
          }),
          _react2.default.createElement('img', {
            alt: 'Press Icon Readwrite',
            className: 'large-upload-panel-testimonial-press-icon',
            src: '/images/readwrite-icon.png'
          }),
          _react2.default.createElement('img', {
            alt: 'Press Icon Huffington Post',
            className: 'large-upload-panel-testimonial-press-icon',
            src: '/images/huff-post-icon.png'
          })
        ) : _react2.default.createElement('img', {
          alt: 'Press Icons',
          className: 'large-upload-panel-testimonial-press-icons',
          src: '/images/press-logos-set.png'
        })
      )
    )
  );
};

EditPDFLandingPageBenefitsSection.defaultProps = {
  isFullWidthUploadPanel: false
};

EditPDFLandingPageBenefitsSection.propTypes = {
  isFullWidthUploadPanel: _propTypes2.default.bool
};

exports.default = EditPDFLandingPageBenefitsSection;

/***/ }),

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _UploadTypes = __webpack_require__(450);

var _UploadTypes2 = _interopRequireDefault(_UploadTypes);

var _LandingPageFullWidthUploadPanelCTA = __webpack_require__(442);

var _LandingPageFullWidthUploadPanelCTA2 = _interopRequireDefault(_LandingPageFullWidthUploadPanelCTA);

var _LandingPagePhotoToPDFModal = __webpack_require__(443);

var _LandingPagePhotoToPDFModal2 = _interopRequireDefault(_LandingPagePhotoToPDFModal);

var _FullWidthUploadPanelRadioButtons = __webpack_require__(1434);

var _FullWidthUploadPanelRadioButtons2 = _interopRequireDefault(_FullWidthUploadPanelRadioButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditPDFLandingPageFullWidthUploadPanel = function (_React$PureComponent) {
  _inherits(EditPDFLandingPageFullWidthUploadPanel, _React$PureComponent);

  function EditPDFLandingPageFullWidthUploadPanel(props) {
    _classCallCheck(this, EditPDFLandingPageFullWidthUploadPanel);

    var _this = _possibleConstructorReturn(this, (EditPDFLandingPageFullWidthUploadPanel.__proto__ || Object.getPrototypeOf(EditPDFLandingPageFullWidthUploadPanel)).call(this, props));

    _this.state = {
      uploadType: _UploadTypes2.default.FreeWrite
    };

    _this.getCTAAndRadioButtons = _this.getCTAAndRadioButtons.bind(_this);
    _this.templateOptionClick = _this.templateOptionClick.bind(_this);
    _this.pdfOnlyClick = _this.pdfOnlyClick.bind(_this);
    _this.rearrangePagesClick = _this.rearrangePagesClick.bind(_this);
    _this.getSubheader = _this.getSubheader.bind(_this);
    _this.onUploadDrop = _this.onUploadDrop.bind(_this);
    _this.activatePDFOnlyButton = _this.activatePDFOnlyButton.bind(_this);
    _this.activateRearrangePagesButton = _this.activateRearrangePagesButton.bind(_this);
    _this.activateTemplateUploadButton = _this.activateTemplateUploadButton.bind(_this);
    return _this;
  }

  _createClass(EditPDFLandingPageFullWidthUploadPanel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Track default radio button selection
      window._track('Edit PDF Only', 'Edit PDF Landing Page');
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      switch (this.state.uploadType) {
        case _UploadTypes2.default.FreeWrite:
          this.activatePDFOnlyButton();
          break;
        case _UploadTypes2.default.Rearrange:
          this.activateRearrangePagesButton();
          break;
        case _UploadTypes2.default.Template:
          this.activateTemplateUploadButton();
          break;
        default:
          break;
      }
    }
  }, {
    key: 'onUploadDrop',
    value: function onUploadDrop() {
      var uploadTrackingType = void 0;
      switch (this.state.uploadType) {
        case _UploadTypes2.default.Template:
          uploadTrackingType = 'Add Fillable Fields';
          break;
        case _UploadTypes2.default.FreeWrite:
          uploadTrackingType = 'Edit PDF Only';
          break;
        case _UploadTypes2.default.Rearrange:
          uploadTrackingType = 'Edit Pages';
          break;
        default:
          break;
      }
      window._track('Drag and Drop Upload Zone | ' + uploadTrackingType, 'Edit PDF Landing Page');
    }
  }, {
    key: 'getSubheader',
    value: function getSubheader() {
      var subHeaderClasses = (0, _classnames2.default)('large-upload-panel-sub-header', { 'subheader-after-cta': this.props.isTemplateOptionAvailable });

      var isTemplateUpload = this.state.uploadType === _UploadTypes2.default.Template;
      var templateOptionSubheader = 'Upload any PDF or Word Document';
      var defaultSubheader = 'Upload any PDF, Word Document, or Image';
      var subHeader = isTemplateUpload ? templateOptionSubheader : defaultSubheader;

      return _react2.default.createElement(
        'p',
        { className: subHeaderClasses },
        subHeader
      );
    }
  }, {
    key: 'getCTAAndRadioButtons',
    value: function getCTAAndRadioButtons() {
      var elements = void 0;
      var subHeader = {
        element: this.getSubheader(),
        key: 'subheader'
      };
      var cta = {
        element: _react2.default.createElement(_LandingPageFullWidthUploadPanelCTA2.default, {
          ctaId: this.props.ctaId,
          ctaOnClick: function ctaOnClick() {
            window._track('Upload a File to Edit', 'Edit PDF Landing Page');
          },
          ctaText: 'Upload a File to Edit'
        }),
        key: 'cta'
      };
      var radioButtons = {
        element: _react2.default.createElement(_FullWidthUploadPanelRadioButtons2.default, {
          isTemplateOptionAvailable: this.props.isTemplateOptionAvailable,
          pdfOnlyClick: this.pdfOnlyClick,
          rearrangePagesClick: this.rearrangePagesClick,
          templateOptionClick: this.templateOptionClick
        }),
        key: 'radioButtons'
      };

      if (this.props.isTemplateOptionAvailable) {
        elements = [radioButtons, cta, subHeader];
      } else {
        elements = [subHeader, cta, radioButtons];
      }

      return _react2.default.createElement(
        'div',
        { className: 'subheader-cta-radio-wrapper' },
        elements.map(function (e) {
          return _react2.default.createElement(
            _react2.default.Fragment,
            { key: e.key },
            e.element
          );
        })
      );
    }
  }, {
    key: 'activatePDFOnlyButton',
    value: function activatePDFOnlyButton() {
      window.Upload.activateUploadButtonById(this.props.ctaId);
      window.UploadDragAndDrop.setUrl('/free-write/scripts/upload_pdf.php');
    }
  }, {
    key: 'activateRearrangePagesButton',
    value: function activateRearrangePagesButton() {
      window.Upload.activateUploadButtonById(this.props.ctaId, _UploadTypes2.default.Rearrange, window.API_URL + '/temporary-document');
      window.Upload.type = _UploadTypes2.default.Rearrange;
      window.UploadDragAndDrop.setUrl('/free-write/scripts/upload_pdf.php');
    }
  }, {
    key: 'activateTemplateUploadButton',
    value: function activateTemplateUploadButton() {
      window.Upload.activateUploadButtonById(this.props.ctaId, 'custom-template', window.API_URL + '/custom-template', true, ['application/msword', 'application/pdf', 'text/plain']);
      window.UploadDragAndDrop.setUrl(window.API_URL + '/custom-template');
      window.UploadDragAndDrop.setUserParams();
    }
  }, {
    key: 'pdfOnlyClick',
    value: function pdfOnlyClick() {
      this.activatePDFOnlyButton();
      window._track('Edit PDF Only', 'Edit PDF Landing Page');
      this.setState({ uploadType: _UploadTypes2.default.FreeWrite });
    }
  }, {
    key: 'rearrangePagesClick',
    value: function rearrangePagesClick() {
      this.activateRearrangePagesButton();
      window._track('Edit Pages', 'Edit PDF Landing Page');
      this.setState({ uploadType: _UploadTypes2.default.Rearrange });
    }
  }, {
    key: 'templateOptionClick',
    value: function templateOptionClick() {
      this.activateTemplateUploadButton();
      window._track('Template Builder', 'Edit PDF Landing Page');
      this.setState({ uploadType: _UploadTypes2.default.Template });
    }
  }, {
    key: 'render',
    value: function render() {
      var wrapperClasses = (0, _classnames2.default)({ 'template-option-available': this.props.isTemplateOptionAvailable });

      return _react2.default.createElement(
        'div',
        { className: 'large-upload-panel-upload-section-wrapper ' + wrapperClasses },
        _react2.default.createElement(
          'div',
          { className: 'upload-wrap edit-pages-upload-wrap hide-for-photos' },
          _react2.default.createElement(
            'form',
            { id: 'dropzoneUploader', className: 'uploader' },
            _react2.default.createElement(
              'div',
              { className: 'alert alert-error uploader-error' },
              'Error'
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'uploader-area edit-pages-uploader-area',
                onDrop: this.onUploadDrop
              },
              _react2.default.createElement('img', {
                src: '/images/blue-doc-icon.png',
                alt: 'Document and Arrow Icon',
                className: 'large-upload-panel-document-icon'
              }),
              _react2.default.createElement(
                'h3',
                { className: 'large-upload-panel-header' },
                this.props.headerCopy
              ),
              this.getCTAAndRadioButtons()
            )
          )
        ),
        _react2.default.createElement(_LandingPagePhotoToPDFModal2.default, null)
      );
    }
  }]);

  return EditPDFLandingPageFullWidthUploadPanel;
}(_react2.default.PureComponent);

exports.default = EditPDFLandingPageFullWidthUploadPanel;


EditPDFLandingPageFullWidthUploadPanel.defaultProps = {
  headerCopy: 'Free PDF Editor',
  isTemplateOptionAvailable: false
};

EditPDFLandingPageFullWidthUploadPanel.propTypes = {
  ctaId: _propTypes2.default.string.isRequired,
  headerCopy: _propTypes2.default.string,
  isTemplateOptionAvailable: _propTypes2.default.bool
};

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditPDFLandingPageRadioButtons = function (_React$PureComponent) {
  _inherits(EditPDFLandingPageRadioButtons, _React$PureComponent);

  function EditPDFLandingPageRadioButtons() {
    _classCallCheck(this, EditPDFLandingPageRadioButtons);

    return _possibleConstructorReturn(this, (EditPDFLandingPageRadioButtons.__proto__ || Object.getPrototypeOf(EditPDFLandingPageRadioButtons)).apply(this, arguments));
  }

  _createClass(EditPDFLandingPageRadioButtons, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "edit-pages-radio-button-wrapper" },
        _react2.default.createElement(
          "div",
          { className: "edit-pages-radio-button-section" },
          _react2.default.createElement(
            "button",
            {
              className: "edit-pages-radio-button-outer free-write active",
              onClick: function onClick(e) {
                EditPDFLandingPageRadioButtons.resetUploadDestination(e, 'free-write');
              }
            },
            _react2.default.createElement("div", { className: "edit-pages-radio-button-inner" })
          ),
          _react2.default.createElement(
            "span",
            { className: "edit-pages-radio-button-text" },
            "I want to edit my PDF only"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "edit-pages-radio-button-section" },
          _react2.default.createElement(
            "button",
            {
              className: "edit-pages-radio-button-outer rearrange",
              onClick: function onClick(e) {
                EditPDFLandingPageRadioButtons.resetUploadDestination(e, 'rearrange');
              }
            },
            _react2.default.createElement("div", { className: "edit-pages-radio-button-inner" })
          ),
          _react2.default.createElement(
            "span",
            { className: "edit-pages-radio-button-text" },
            "I want to edit my PDF & rearrange pages"
          )
        )
      );
    }
  }], [{
    key: "resetUploadDestination",
    value: function resetUploadDestination(clickEvent, destination) {
      clickEvent.preventDefault();
      window.Upload.resetUploadDestination(clickEvent, destination);
    }
  }]);

  return EditPDFLandingPageRadioButtons;
}(_react2.default.PureComponent);

exports.default = EditPDFLandingPageRadioButtons;

/***/ })

},[1320]);


// WEBPACK FOOTER //
// edit-pdf-landing-page.js